/**
 * MediaPipe Pose (Tasks API) landmark indices — 33-point BlazePose topology.
 * Only the subset listed in CLAUDE.md ("랜드마크 인덱스") is used by this app.
 *
 * In a side view we use the camera-side limbs only; `qualityGate` decides which
 * side faces the camera and `sideLandmarks()` maps that to concrete indices.
 */
export const LM = {
    NOSE: 0,
    /** Outer eye corner ≈ lateral canthus, the front point of the CHA line. */
    LEFT_EYE_OUTER: 3,
    RIGHT_EYE_OUTER: 6,
    LEFT_EAR: 7,
    RIGHT_EAR: 8,
    LEFT_SHOULDER: 11,
    RIGHT_SHOULDER: 12,
    LEFT_ELBOW: 13,
    RIGHT_ELBOW: 14,
    LEFT_WRIST: 15,
    RIGHT_WRIST: 16,
    LEFT_INDEX: 19,
    RIGHT_INDEX: 20,
    LEFT_HIP: 23,
    RIGHT_HIP: 24,
    LEFT_KNEE: 25,
    RIGHT_KNEE: 26,
    LEFT_ANKLE: 27,
    RIGHT_ANKLE: 28,
};
export const LANDMARK_COUNT = 33;
export function sideLandmarks(side) {
    return side === 'left'
        ? {
            eyeOuter: LM.LEFT_EYE_OUTER,
            ear: LM.LEFT_EAR,
            shoulder: LM.LEFT_SHOULDER,
            elbow: LM.LEFT_ELBOW,
            wrist: LM.LEFT_WRIST,
            index: LM.LEFT_INDEX,
            hip: LM.LEFT_HIP,
            knee: LM.LEFT_KNEE,
            ankle: LM.LEFT_ANKLE,
        }
        : {
            eyeOuter: LM.RIGHT_EYE_OUTER,
            ear: LM.RIGHT_EAR,
            shoulder: LM.RIGHT_SHOULDER,
            elbow: LM.RIGHT_ELBOW,
            wrist: LM.RIGHT_WRIST,
            index: LM.RIGHT_INDEX,
            hip: LM.RIGHT_HIP,
            knee: LM.RIGHT_KNEE,
            ankle: LM.RIGHT_ANKLE,
        };
}
/** The 12 landmarks persisted for model retraining (DATA_AND_ML §5 window spec). */
export const TRAINING_LANDMARKS = [
    LM.NOSE,
    LM.LEFT_EAR,
    LM.RIGHT_EAR,
    LM.LEFT_SHOULDER,
    LM.RIGHT_SHOULDER,
    LM.LEFT_ELBOW,
    LM.RIGHT_ELBOW,
    LM.LEFT_HIP,
    LM.RIGHT_HIP,
    LM.LEFT_KNEE,
    LM.RIGHT_KNEE,
    LM.LEFT_ANKLE,
];
//# sourceMappingURL=landmarks.js.map